module.exports = __webpack_public_path__ + "static/media/29ADMSPC37.ac6da204.jpg";